import React from "react";
import "./index.scss";
import Button from "../../shared/Button";

interface Props {
  blockTitle: string;
  textHtml: string;
  hintHtml: string;
  downloadUrl: string;
}

export const SignTextBlock: React.FC<Props> = ({
                                                 blockTitle,
                                                 textHtml,
                                                 hintHtml,
                                                 downloadUrl
                                               }) => {
  return (
    <div className="signtext">
      <h1 className="form__title">{blockTitle}</h1>
      <div className="signtext__content">

        <div className="signtext__left">
          <div className="signtext__scroll">
            <div
              dangerouslySetInnerHTML={{__html: textHtml}}
            />
          </div>
        </div>

        <div className="signtext__right">
          <div className="signtext__hint-title">Подсказка</div>

          <div
            className="signtext__hint-body"
            dangerouslySetInnerHTML={{__html: hintHtml}}
          />
          <div className="signtext__download">
            <Button
              className='button_secondary'
              {...{
                type: "button",
                onClick: () => {
                  window.open(downloadUrl, "_blank")
                },
              }}
            >
              ⬇ Скачать
            </Button>
          </div>
        </div>

      </div>
    </div>
  )
};



